import { Button, DashboardContainer } from "components"
import { useLocation } from "react-router-dom"
import { useGet } from "utils/useFetch"

import { LoadingIndicatorWhite } from "components/custom/LoaderWhite"
import { useRef } from "react"
import ReactToPrint from "react-to-print"
import NHFReportToPrint from "./NHFReportToPrint"
import { CSVLink } from "react-csv"
import { useQuery } from "@tanstack/react-query"
import {
  paymentSchedulesService,
  PAYMENT_SCHEDULES_ENDPOINTS,
} from "services/paymentSchedulesService"
import { IReportSummaryRes } from "../../typings"

const NHFReport = () => {
  const typeId = "4"
  const myParam = useLocation().search
  const x = new URLSearchParams(myParam).get("x")
  const id = new URLSearchParams(myParam).get("id")
  const componentRef: any = useRef()

  const { isLoading: isPayslipLoading, data } = useQuery<IReportSummaryRes>({
    queryFn: () => paymentSchedulesService.viewScheduleReport(x, typeId, false),
    queryKey: [PAYMENT_SCHEDULES_ENDPOINTS.VIEW_SCHEDULE_REPORT, x, typeId],
  })
  const headers = [
    { label: "NHF", key: "location_name" },
    { label: "Name", key: "full_name" },
    { label: "NHF_NO", key: "nhf_epn" },
    { label: "Employer", key: "employer_contribution" },
    { label: "Employee", key: "employee_contribution" },

    { label: "Total", key: "total" },
  ]

  const csvProps = {
    filename: `${data?.data?.report_download_title}.csv`,
    headers: headers,
    data: data?.data?.nhfSchedules || [],
  }
  return (
    <DashboardContainer>
      <>
        {isPayslipLoading ? (
          <div className="h-[200px] items-center flex justify-center">
            <LoadingIndicatorWhite />
          </div>
        ) : (
          <div>
            <div className="flex justify-end items-center mb-1 gap-4">
              {" "}
              {componentRef && (
                <ReactToPrint
                  trigger={() => (
                    <Button
                      color="primary"
                      title="Download"
                    >
                      Download
                    </Button>
                  )}
                  content={() => componentRef.current}
                  documentTitle={`${data?.data?.report_download_title}.pdf`}
                />
              )}
              <CSVLink {...csvProps}>
                <Button
                  color="primary"
                  title="Download"
                >
                  Download CSV
                </Button>
              </CSVLink>
            </div>
            <NHFReportToPrint
              ref={componentRef}
              data={data?.data ?? {}}
            />
          </div>
        )}
      </>
    </DashboardContainer>
  )
}
export default NHFReport
